// stores + constants
import store from '~/components/betslip/betslip.store';
// utils
import { getEnvironment } from '~/components/betslip/util/utils';

export interface ISiteConfigActions {
	getSiteConfigVar: (key: string) => boolean;
}

const isTest = process.env.NODE_ENV === 'test';

class SiteConfigActions implements ISiteConfigActions {
	private env: 'prod' | 'green' | 'stg';

	private updateClient: (key: string, val: any) => void;

	constructor(shouldInitSiteConfigVars?: boolean) {
		if (typeof window === 'undefined' || !shouldInitSiteConfigVars || isTest) {
			return;
		}

		this.setEnvironment();
		// this.initSiteConfigVars();
		this.updateClient = store.getState().updateClient;
	}

	private setEnvironment(): void {
		const environment = getEnvironment(window.location.hostname);

		switch (true) {
			case environment.isProd:
				this.env = 'prod';
				break;

			case environment.isGreen:
				this.env = 'green';
				break;

			case environment.isLocal:
			case environment.isTest:
			case environment.isStg:
			case environment.isEphemeral:
			default:
				this.env = 'stg';
				break;
		}
	}

	private async initSiteConfigVars(): Promise<void> {
		try {
			const url = `/site-config/${this.env}`;
			const options = {
				headers: { 'Content-Type': 'application/json' },
			};

			const res = await fetch(url, options);
			const data = await res.json();

			const siteConfigVars = data.propertySources[0].source;
			if (typeof siteConfigVars !== 'undefined') {
				this.updateClient('siteConfigVars', siteConfigVars);

				const event = new CustomEvent('OC:siteConfigLoaded');
				window.dispatchEvent(event);
			}
		} catch (err) {
			console.log('error at SiteConfigActions initSiteConfigVars');
			console.error(err);
		}
	}

	public getSiteConfigVar(key: string): boolean {
		const siteConfigVars = store.getState().client.siteConfigVars;

		if (siteConfigVars && key in siteConfigVars) {
			return siteConfigVars[key] === 'true';
		}
	}
}

export default SiteConfigActions;
